import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-monitor",
  "use": "icon-monitor-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-monitor\"><defs><style type=\"text/css\"></style></defs><path d=\"M768 928V1024H256v-96h512zM513.024 286.976l163.84 273.024H1024V768a64 64 0 0 1-64 64H64a64 64 0 0 1-64-64V496h102.272l156.864 235.264 253.888-444.288zM960 0a64 64 0 0 1 64 64v400h-292.8l-220.16-366.976L252.8 548.672 153.664 400H0V64a64 64 0 0 1 64-64h896z\" fill=\"#BFCBD9\" p-id=\"2877\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol